import type { FC } from "react";
import { memo } from "react";
import Moment from "react-moment";

import type { INews } from "../../hooks/reactQueryHooks/useNews";
import { RoundedStatusBadge } from "../RoundedStatusBadge/RoundedStatusBadge";

interface INewsItemProps {
  news: INews;
  lastVisitTime: number | null;
}

const NewsItem: FC<INewsItemProps> = memo(({ news, lastVisitTime }) => {
  const showNewBadge =
    !lastVisitTime || new Date(news.postedAt).getTime() > lastVisitTime;
  return (
    <div className="news-item">
      <div className="news-item-date">
        <Moment format="MMMM Do, YYYY">{news.postedAt}</Moment>
      </div>
      <div className="news-item-content">
        <div className="news-item-title">
          <h5>{news.title}</h5>
          {showNewBadge && (
            <RoundedStatusBadge variant="red">NEW</RoundedStatusBadge>
          )}
        </div>
        <p>{news.content}</p>

        {news.url && (
          <a
            className="news-item-link"
            href={news.url}
            target="__blank"
            rel="noopener noreferrer"
          >
            Learn more on our blog {">"}
          </a>
        )}
      </div>
    </div>
  );
});

export { NewsItem };
